import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useQuery } from '@apollo/client';
import { Metric } from '@src/components/Admin/Metric/Metric';
import { UTILIZATION_STATS } from '@src/graphql/queries/dashboard';
import { useLocale } from 'pe-core-frontend';
export const DashboardUtilizationStats = ({ client, year }) => {
    const { t } = useLocale();
    const { data: statsData } = useQuery(UTILIZATION_STATS, {
        variables: {
            spec: {
                clientId: client.id,
                capYear: year,
            },
        },
    });
    // const chartData = useMemo(() => {
    //   if (!statsData?.utilizationStats) return [];
    //   return [
    //     {
    //       name: t('Utilization'),
    //       ...statsData.utilizationStats,
    //     },
    //   ];
    //   // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, [statsData]);
    const { utilized, signedUp, total } = statsData?.utilizationStats || {
        utilized: 0,
        signedUp: 0,
        total: 1,
    };
    const getPercentage = (value) => {
        if (!total)
            return 0;
        const percent = (100 * value) / total;
        if (percent < 1) {
            // round to 2 decimal places if less than 1%
            return percent.toFixed(2);
        }
        return percent.toFixed(0);
    };
    return (_jsxs(_Fragment, { children: [_jsx(Metric, { label: t('Employees signed up'), values: [statsData?.utilizationStats?.signedUp || 0, `${getPercentage(signedUp)}%`], helpText: t('(All Time)') }), _jsx(Metric, { label: t('Employees using the benefit'), values: [statsData?.utilizationStats?.utilized || 0, `${getPercentage(utilized)}%`], helpText: t('(All Time)') })] })
    // <div>
    //   <Typography className='flex flexJustify--start' variant='title3'>
    //     {t('Benefit Utilization by Employees')}
    //   </Typography>
    //   <ResponsiveContainer width='100%' height={400}>
    //     <BarChart
    //       width={500}
    //       height={300}
    //       data={chartData}
    //       layout='vertical'
    //       margin={{
    //         top: 20,
    //         right: 30,
    //         left: 20,
    //         bottom: 5,
    //       }}
    //     >
    //       <CartesianGrid strokeDasharray='3 3' />
    //       <XAxis type='number' />
    //       <YAxis type='category' dataKey='name' width={100} />
    //       <Tooltip />
    //       <Legend />
    //       <Bar dataKey='utilized' fill='#93c37d' name={t('Utilized')} />
    //       <Bar dataKey='signedUp' fill='#e0b32d' name={t('Signed Up')} />
    //       <Bar dataKey='total' fill='#a4c2f4' name={t('Total')} />
    //     </BarChart>
    //   </ResponsiveContainer>
    // </div>
    );
};
